<template>
  <div>
    <recording-start-button
      v-show="shouldShowStartButton"
      :disabled="isRecordingDisabled" />

    <recording-pause-stop-button
      v-show="shouldPauseStopButton"
      :disabled="recordingButtonDisabled" />

    <recording-resume-button
      v-show="recordingState === 'paused'"
      :disabled="recordingButtonDisabled" />

    <recording-stopped-label
      v-show="recordingState === 'stopped'" />
  </div>
</template>

<script>
  import store from '@/lib/store'
  import { createNamespacedHelpers } from 'vuex'
  import RecordingStartButton from './recording-start-button'
  import RecordingPauseStopButton from './recording-pause-stop-button'
  import RecordingResumeButton from './recording-resume-button'
  import RecordingStoppedLabel from './recording-stopped-label'

  const { mapState, mapGetters } = createNamespacedHelpers('conference')

  export default {
    components: {
      RecordingStartButton,
      RecordingPauseStopButton,
      RecordingResumeButton,
      RecordingStoppedLabel
    },
    data () {
      return {
        user: store.get('user')
      }
    },
    computed: {
      ...mapState([
        'activity',
        'recordingButtonDisabled'
      ]),
      ...mapGetters([
        'callStatus'
      ]),
      isAutoRecordEnabled () {
        return this.user.softphoneOutboundRecordPreference
      },
      recordingState () {
        return this.activity.recordingState
      },
      isRecordingDisabled () {
        return this.recordingButtonDisabled || (!this.recordingState && !this.isPromptReason && this.callStatus === 'pending')
      },
      isRecordingStateOff () {
        return !this.recordingState || this.recordingState === 'off'
      },
      isPromptReason () {
        return this.activity.recordingReasonCode === 'prompt'
      },
      shouldShowStartButton () {
        return (this.isRecordingStateOff && !this.isAutoRecordEnabled) || (this.isRecordingStateOff && this.isPromptReason)
      },
      shouldPauseStopButton () {
        return this.recordingState === 'in-progress' || ((this.isRecordingStateOff && this.isAutoRecordEnabled) && !this.isPromptReason)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// recording-button.vue?1abdfa8a